import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { FormHandles } from "@unform/core";

import { LoadingComp } from "../../../../../shared/components/loading/Loading";
import { VForm, VTextField } from "../../../../../shared/forms";
import { ISimulateEditProposal } from "../../../../../shared/services/api/proposal/ProposalEditService";

interface ValidityTabProps {
	formRef: React.RefObject<FormHandles>;
	isLoading: boolean;
	onSubmit: (dados: ISimulateEditProposal) => void;
	setContractBegin: (value: string) => void;
	setContractEnd: (value: string) => void;
	setTermBegin: (value: string) => void;
	setTermEnd: (value: string) => void;
}

export const ValidityTab: React.FC<ValidityTabProps> = ({
	formRef,
	isLoading,
	onSubmit,
	setContractBegin,
	setContractEnd,
	setTermBegin,
	setTermEnd,
}) => {
	return (
		<Box>
			{isLoading && <LoadingComp isopen />}
			<VForm id="formIdSimulation" ref={formRef} onSubmit={onSubmit} onPointerEnterCapture={''} onPointerLeaveCapture={''} placeholder={''}>
				<Box margin={0} display="flex" flexDirection="column" component={Paper} variant="elevation" elevation={0}>
					<Grid container item direction="column" padding={2} spacing={2}>
						<Grid container item direction="row" spacing={2}>
							<Grid item xs={11}>
								<Typography variant="h6" color={"primary"}>
									Alteração de Vigência
								</Typography>
							</Grid>

							<Grid container item direction="row" spacing={2}>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField
										fullWidth
										label="Inicio do contrato de locação"
										name="contractBegin"
										disabled={isLoading}
										type="date"
										onChange={(e) => setContractBegin(e.target.value)}
									/>
								</Grid>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField
										fullWidth
										label="Fim do contrato de locação"
										name="contractEnd"
										disabled={isLoading}
										onChange={(e) => setContractEnd(e.target.value)}
										type="date"
									/>
								</Grid>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField fullWidth label="Vigência Locação" name="rentMonthsCountContract" disabled={true} />
								</Grid>
							</Grid>

							<Grid container item direction="row" spacing={2}>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField
										fullWidth
										label="Inicio da Vigencia"
										name="termBegin"
										disabled={isLoading}
										onChange={(e) => setTermBegin(e.target.value)}
										type="date"
									/>
								</Grid>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField
										fullWidth
										label="Fim da Vigencia"
										name="expiresAt"
										disabled={isLoading}
										onChange={(e) => setTermEnd(e.target.value)}
										type="date"
									/>
								</Grid>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField fullWidth label="Vigência da garantia" name="rentMonthsCount" disabled={true} />
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</VForm>
		</Box>
	);
};
